import FA from 'react-fontawesome';

/*
  Part 1 of upgrading to FontAwesome 5 (Pro)
  - replacing the `font-awesome` package with `@fortawesome/fontawesome-pro`
  - replacing references to v4 (s)css files with v5 files
  - using a v4 shim which allows us to keep old version 4 icon names, aliases etc
    and continue to use the `react-fontawesome` component

  TODO: Delete this component and remove `react-fontawesome` package
  once we have replaced all references to this <FontAwesome> component
  with the new <FontAwesomeIcon> component from the
  `@fortawesome/react-fontawesome` package
*/

import '@fortawesome/fontawesome-pro/css/all.css';
import '@fortawesome/fontawesome-pro/css/v4-shims.css';

// Deprecated!! Use FontAwesomeIcon
export const FontAwesome = FA;
